module.exports = __webpack_public_path__ + "img/hito002.87699a49.webp";